const config = {
  siteUrl: "",

  galleydynamic: [
    "images/gallery-slide1.png",
    "images/gallery-slide2.png",
    "images/gallery-slide3.png",
    "images/gallery-slide4.png",
    "images/classroom.jpg",
    "images/classroom2.jpg",
    "images/gd-session.jpg",
    "images/Himachal-confrains.jpg",
    "images/National-day.jpg",
    "images/HRC-session-Bang.jpg",
    "images/navyug.jpg",
    "images/phd-session.jpg",
    "images/batch1-scholar-staff.png",
    "images/batch1-research-center.png",
    "images/batch1-exam.png",
    "images/batch1-viva.png",
    "images/batch3-bos-member.png",
    "images/iimb-conference.png",
    "images/informl-discussion.png",
    "images/international-conference-hrc.png",
    "images/inspection.png",
    "images/seminar-room.png",
    "images/seminar-staff.png",
    "images/ecg-signal.png",
  ],
};

module.exports = config;
